import React, {Component} from 'react';

class SingleGrowl extends Component {
  render() {
    const { type, message } = this.props;
    return (
      <li className={`c-growler-message c-growler-message__${type}`}><span>{type}: {message}</span></li>
    );
  }
}

export default SingleGrowl;



// WEBPACK FOOTER //
// ./src/components/SingleGrowl.js